/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_Faq_4_QInputs */

const en_vc_onl_faq_4_q = /** @type {(inputs: Vc_Onl_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the difference between VectorCraft online and the desktop app?`)
};

const zh_vc_onl_faq_4_q = /** @type {(inputs: Vc_Onl_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在线版和桌面版有什么区别？`)
};

/**
* | output |
* | --- |
* | "What is the difference between VectorCraft online and the desktop app?" |
*
* @param {Vc_Onl_Faq_4_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_faq_4_q = /** @type {((inputs?: Vc_Onl_Faq_4_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_Faq_4_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_faq_4_q(inputs)
	return zh_vc_onl_faq_4_q(inputs)
});
export { vc_onl_faq_4_q as "vc.onl.faq.4.q" }